/** Must match backend FREE_SIGNUP_CREDITS default / .env. */
export const FREE_SIGNUP_CREDITS = 6

export function formatSignupCreditsLabel(count: number = FREE_SIGNUP_CREDITS): string {
  return `${count} ${count === 1 ? 'кредит' : count >= 2 && count <= 4 ? 'кредита' : 'кредитов'}`
}
